var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282829",
    fillRule: "nonzero",
    d: "M12.5 15h-10a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V10a.5.5 0 0 1 1 0v4a1 1 0 0 1-1 1M10 2.5a.5.5 0 0 0 .5.5h2.295L8.852 6.942a.5.5 0 0 0 .705.705L13.5 3.705V6a.5.5 0 0 0 1 0V2.5A.5.5 0 0 0 14 2h-3.5a.5.5 0 0 0-.5.5"
  })));
};
export default SvgExternalLink;